export const flowOrderZH = {
  flowOrder1: '全部订单',
  flowOrder2: '项目名称',
  flowOrder3: '费用类型',
  flowOrder4: '费用项',
  flowOrder5: '金额',
  flowOrder6: '状态',
  flowOrder7: '操作',
  flowOrder8: '订单号',
  flowOrder9: '订单详情',
  flowOrder10: '申请退款',
  flowOrder11: '没有更多了~',
  flowOrder12: '申请发票',
  flowOrder13: '电子发票与纸质发票具有同等法律效力，可支持报销入账',
  flowOrder14: '开票中',
  flowOrder15: '开票失败',
  flowOrder16: '开票失败，请将“姓名+订单号”信息发送至邮箱 bloom@sktedu.com，我们将尽快为您处理。',
  flowOrder17: '开票成功',
  flowOrder18: '开票成功后，请点击下方“发送邮件”，发送至邮箱并自行下载打印',
  flowOrder19: '订单信息',
  flowOrder20: '实付金额',
  flowOrder21: '发票信息',
  flowOrder22: '发票类型',
  flowOrder23: '电子发票',
  flowOrder24: '抬头类型',
  flowOrder25: '企业单位',
  flowOrder26: '个人/非企业单位',
  flowOrder27: '发票抬头',
  flowOrder28: '税号',
  flowOrder29: '发票内容',
  flowOrder30: '发票金额',
  flowOrder31: '申请时间',
  flowOrder32: '你已成功发起发票申请，我们将于7个工作日内处理完，请注意查看~',
  flowOrder33: '请输入邮箱',
  flowOrder34: '发送至',
  flowOrder35: '我们已将发票发送至你的邮箱，请注意查收~',
  flowOrder36: '发送成功',
  flowOrder37: '获取专属邀请码',
  flowOrder38: '你的专属邀请码：',
  flowOrder39: '复制',
  flowOrder40: '支付方式',
  flowOrder41: '支付时间',
  flowOrder42: '姓名',
  flowOrder43: '身份证',
  flowOrder44: '护照号',
  flowOrder45: '证件号',
  flowOrder46: '优惠券',
  flowOrder47: '退款总额',
  flowOrder48: '实付总额',
  flowOrder49: '费用说明',
  flowOrder50: '您的订单无法申请电子发票，如需发票请致电0755-86571607。',
  flowOrder51: '支付宝',
  flowOrder52: '微信',
  flowOrder53: '已支付',
  flowOrder54: '退款中',
  flowOrder55: '已退款',
  flowOrder56: '退款失败',
  flowOrder57: '复制成功',
  flowOrder58: '您的订单无法申请线上退款，如需退款请联系校园合作代表。',
  flowOrder59: '您的订单已开具发票，无法进行退款。',
  flowOrder60: '申请发票成功后，将无法申请退款',
  flowOrder61: '自助开票功能将在活动结束后开通。出境项目及异常情况请联系咨询老师人工处理。咨询老师联系方式https://www.webloom.cn/bloom_web/#/contact',
  flowOrder62: '退款金额',
  flowOrder63: '退款说明',
  flowOrder64: '填写退款说明',
  flowOrder65: '请填写退款理由',
  flowOrder66: '我的订单',
  flowOrder67: '优惠',
  flowOrder68: '退款',
  flowOrder69: '实付金额',
  flowOrder70: '您的订单无法申请电子发票，如需发票请联系校园合作代表。',
  flowOrder71: '暂无订单',
  flowOrder72: '查看订单详情',
  flowOrder73: '开具电子发票',
  flowOrder74: '申请电子发票',
  flowOrder75: '填写发票抬头',
  flowOrder76: '请填写企业名称',
  flowOrder77: '设置邮箱',
  flowOrder78: '说明：请输入新邮箱后，再点击提交，系统会给您重新发送电子发票。',
  flowOrder79: '发送成功，请去邮箱查看',
  flowOrder80: '护照',
  flowOrder81: '填写退款说明，您的反馈是我们前进的动力！',
  flowOrder82: '未开票',
  flowOrder83: '已开票',
  flowOrder84: '已红冲',
  flowOrder85: '电子邮箱',
  flowOrder86: '发送邮箱',
  flowOrder87: '申请纸质发票',
  flowOrder88: '请仔细核对开票信息，确认提交后将无法修改。',
  flowOrder89: '确认提交',
  flowOrder90: '说明：如需修改邮箱，请在上方填写新邮箱后再提交。。',
  flowOrder91: '账号绑定',
  flowOrder92: '支付成功',
  flowOrder94: '填写企业纳税人识别号',
  flowOrder95: '发送邮件'
}

export const flowOrderEN = {
  flowOrder1: 'All Orders',
  flowOrder2: 'Project Name',
  flowOrder3: 'Expense Type',
  flowOrder4: 'Fees',
  flowOrder5: 'Amount',
  flowOrder6: 'State',
  flowOrder7: 'Operate',
  flowOrder8: 'Order Number',
  flowOrder9: 'Order Details',
  flowOrder10: 'Request a refund',
  flowOrder11: 'No more~',
  flowOrder12: 'To request an invoice',
  flowOrder13: 'Electronic invoices have the same legal effect as paper invoices and can support reimbursement accounting',
  flowOrder14: 'Invoicing',
  flowOrder15: 'Invoicing Failed',
  flowOrder16: 'If the invoicing failed,, please send the "name + order number" information to the mailbox bloom@sktedu.com, and we will process it for you as soon as possible. ',
  flowOrder17: 'Invoicing successful',
  flowOrder18: 'After the invoice is successfully issued, please click "Send Email" below to send it to your email,and you can download and print it by yourself',
  flowOrder19: 'Order Information',
  flowOrder20: 'Actual Payment',
  flowOrder21: 'Invoice Information',
  flowOrder22: 'Invoice Type',
  flowOrder23: 'E-invoicing',
  flowOrder24: 'Header Type',
  flowOrder25: 'Enterprises',
  flowOrder26: 'Individual/Non-Business Entity',
  flowOrder27: 'Invoice Title',
  flowOrder28: 'Tax ID',
  flowOrder29: 'Invoice contents',
  flowOrder30: 'Invoice Amount',
  flowOrder31: 'Application Period',
  flowOrder32: 'You have successfully initiated an invoice application, we will process it within 7 working days, please pay attention to check~',
  flowOrder33: 'Please enter your email address',
  flowOrder34: 'Send to',
  flowOrder35: 'We have sent the invoice to your email,please check your inbox~',
  flowOrder36: 'Sent successfully',
  flowOrder37: 'Get an exclusive invitation code',
  flowOrder38: 'Your exclusive invitation code',
  flowOrder39: 'Copy',
  flowOrder40: 'Payment Methods',
  flowOrder41: 'Payment time',
  flowOrder42: 'Name',
  flowOrder43: 'ID card',
  flowOrder44: 'Passport Number',
  flowOrder45: 'ID Number',
  flowOrder46: 'Coupon',
  flowOrder47: 'Total refund amount',
  flowOrder48: 'Total payment amount',
  flowOrder49: 'Fee Description',
  flowOrder50: 'Your order cannot be e-invoiced, if you need an invoice, please call 0755-86571607. ',
  flowOrder51: 'Alipay',
  flowOrder52: 'Wechat',
  flowOrder53: 'Paid',
  flowOrder54: 'Refund in progress',
  flowOrder55: 'Refunded',
  flowOrder56: 'Refund Failed',
  flowOrder57: 'Copied successfully',
  flowOrder58: 'Online refunds are not available for your order, Please contact a Campus Partnership Representative if you need a refund.',
  flowOrder59: 'Your order has already been invoiced and cannot be refunded. ',
  flowOrder60: 'Once you have successfully applied for an invoice, you will not be able to apply for a refund',
  flowOrder61: 'Self-service invoicing will be available after the activity ends. For outbound items and abnormal situations, please contact the consultant for manual handling. Contact information of the consulting teacher https://www.webloom.cn/bloom_web/#/contact',
  flowOrder62: 'Refund Amount',
  flowOrder63: 'Refund Instructions',
  flowOrder64: 'Fill in the refund instructions',
  flowOrder65: ' Please fill in the reasons for the refund',
  flowOrder66: 'My order',
  flowOrder67: 'Discount',
  flowOrder68: 'Refund',
  flowOrder69: 'Actual payment amount',
  flowOrder70: 'Your order cannot be refunded online. If you need a refund, please contact the campus cooperation representative.',
  flowOrder71: 'No orders',
  flowOrder72: 'View Order Details',
  flowOrder73: 'Open e-invoice',
  flowOrder74: 'Apply for e-invoice',
  flowOrder75: 'Fill in the invoice header',
  flowOrder76: 'Please fill in your company name',
  flowOrder77: 'Set up email address',
  flowOrder78: 'Explanation: Please enter the new email address and then click submit, the system will resend the e-invoice to you.',
  flowOrder79: 'Sent successfully, please check your inbox',
  flowOrder80: 'Passport',
  flowOrder81: 'Fill in the refund instructions, and your feedback will drive us forward!',
  flowOrder82: 'Uninvoiced',
  flowOrder83: 'Invoiced',
  flowOrder84: 'Red Flush',
  flowOrder85: 'Email',
  flowOrder86: 'Send Email',
  flowOrder87: 'Apply for paper invoice',
  flowOrder88: 'Please check the invoicing information carefully, you cannot change it after confirming the submission.',
  flowOrder89: 'Confirm submission',
  flowOrder90: 'Note: If you need to change your email address, please fill in the new email address above before submitting.',
  flowOrder91: 'Account Binding',
  flowOrder92: 'Payment successful',
  flowOrder94: 'Enterprise Tax ID Number',
  flowOrder95: 'Send Mail'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/order.js